import React from 'react';
import { Box, Typography, alpha } from '@mui/material';

interface StatTileProps {
  icon: React.ReactNode;
  label: string;
  value: number | string;
  accentColor?: string;
}

const StatTile = ({ icon, label, value, accentColor = '#38bdf8' }: StatTileProps) => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 4,
        p: 2.5,
        pl: 3,
        color: '#fff',
        backgroundColor: alpha('#ffffff', 0.05),
        border: `1px solid ${alpha(accentColor, 0.35)}`,
        boxShadow: `0 10px 24px rgba(0,0,0,0.35)`,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        transition: 'transform 0.25s ease, border-color 0.25s ease',
        '&:hover': {
          transform: 'translateY(-3px)',
          borderColor: alpha(accentColor, 0.6),
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: 4,
          backgroundColor: accentColor,
        }}
      />
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          fontSize: 24,
          backgroundColor: alpha(accentColor, 0.15),
          color: accentColor,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: alpha('#fff', 0.6),
          }}
        >
          {label}
        </Typography>
        <Typography sx={{ fontSize: 28, fontWeight: 800, lineHeight: 1.2, mt: 0.25 }}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatTile;
